import { FC } from 'react';

const Step1: FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      version="1.1"
      id="Capa_2_00000165934293361369341820000008072165751577516963_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      height={100}
      fill={color}
      xmlSpace="preserve"
    >
      <g>
        <path
          fill={color}
          d="M664,883.3h-292c-7.8,0-14.2-5.6-14.9-13.3c-0.2-1.6-4.5-27.5-34.1-68.4c-4.7-6.6-10.1-13.2-15.3-19.7
        c-19-23.7-38.6-48.3-38.6-77.6V561.4c0-23.2,18.9-42.1,42.1-42.1h56V315.3c0-35.6,28.9-64.5,64.5-64.5s64.5,28.9,64.5,64.5v134.4
        L664,485.8c50.4,10.8,82.8,60.7,72.2,111.1l-57.5,274.5C677.3,878.3,671.1,883.3,664,883.3z M384,853.3h267.9l55-262.5
        c7.2-34.3-14.9-68.3-49.2-75.6l-179.6-38.6c-6.9-1.5-11.8-7.6-11.8-14.7V315.3c0-19-15.5-34.5-34.5-34.5c-19,0-34.5,15.5-34.5,34.5
        v324.3c0,8.3-6.7,15-15,15s-15-6.7-15-15v-90.2h-56c-6.6,0-12.1,5.4-12.1,12.1v142.8c0,18.8,15.6,38.2,32.1,58.8
        c5.4,6.7,11,13.7,16.2,20.9C370.1,815.3,379.8,839.3,384,853.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M432.6,214.4c-8.3,0-15-6.7-15-15v-85.8c0-8.3,6.7-15,15-15s15,6.7,15,15v85.8C447.6,207.7,440.9,214.4,432.6,214.4z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M350.2,246.8c-3.8,0-7.7-1.5-10.6-4.4L279,181.7c-5.9-5.9-5.9-15.4,0-21.2c5.9-5.9,15.4-5.9,21.2,0l60.7,60.7
        c5.9,5.9,5.9,15.4,0,21.2C357.9,245.3,354.1,246.8,350.2,246.8z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M316.8,330.8H231c-8.3,0-15-6.7-15-15s6.7-15,15-15h85.8c8.3,0,15,6.7,15,15S325.1,330.8,316.8,330.8z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M515,250.8c-3.8,0-7.7-1.5-10.6-4.4c-5.9-5.9-5.9-15.4,0-21.2l60.7-60.7c5.9-5.9,15.4-5.9,21.2,0c5.9,5.9,5.9,15.4,0,21.2
        l-60.7,60.7C522.6,249.4,518.8,250.8,515,250.8z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M634.1,334.9h-85.8c-8.3,0-15-6.7-15-15s6.7-15,15-15h85.8c8.3,0,15,6.7,15,15S642.4,334.9,634.1,334.9z"
        />
      </g>
    </svg>
  );
};

export default Step1;
